import { IncidentTypeService, IncidentCategoryService } from '@planning/proxy/planning/controllers';
import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const INCIDENTCAUSE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('incidentCategoryId', 'Entity.IncidentCategory', IncidentCategoryService)
    .required()
    .displayFromNested('incidentCategory.name')
    .sortBy('incidentCategory.name')
    .build(),
  FieldBuilder
    .foreignKey('incidentTypeId', 'Entity.IncidentType', IncidentTypeService)
    .required()
    .displayFromNested('incidentType.name')
    .sortBy('incidentType.name')
    .build(),
];

export const INCIDENTCAUSE_CONFIG = {
  entityName: 'IncidentCause',
  localizationKey: 'Planning::Entity.IncidentCause',
  fields: INCIDENTCAUSE_FIELDS,
  permission: 'ResearchAndDevelopmentIncident.IncidentCauses',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Incident + MENU_NAME_SUFFIX,
};
